<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      OrganizationId:
      <input type="text" [(ngModel)]="seConfiguration.organizationId" />
    </label>
  </div>
</div>
<div class="cell small-12">
  Select Group All Org Contacts will be assigned to upon cancellation:
</div>
<div class="cell small-12">
  <select [(ngModel)]="seConfiguration.groupIdToAssignUsersTo">
    @for (group of availableGroups; track group) {
      <option [value]="group.id">{{group.displayName}}</option>
    }
  </select>
</div>